// src/services/adminApi.js
import axios from 'axios';
import { BACKENDURL } from '../../components/constants';

const adminApi = axios.create({
  baseURL: BACKENDURL,
});

// Request interceptor to include admin token
adminApi.interceptors.request.use((config) => {
  const admin = JSON.parse(localStorage.getItem('admin'));
  if (admin?.token) {
    config.headers.Authorization = `Bearer ${admin.token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor for error handling
adminApi.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      // Auto logout if 401 response
      localStorage.removeItem('admin');
      window.location = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default adminApi;